<template>
  <div :style="{ 'background-color': waiverConfigurations.background_color, 'overflow': 'auto',
  'position' : 'absolute',
  'top' : '0px',
    'right' : '0px',
  'bottom':'0px',
  'left':'0px'}">
    <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + waiverConfigurations.font_family">
    <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + waiverConfigurations.font_family_card">

    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
    <not-found-page v-show="notFound"></not-found-page>
    <div v-show="!notFound" class="row mt-2 mr-2 justify-content-end text-right">
      <div class="col-auto">
        <language-switcher v-if="waiverConfigurations && Number(waiverConfigurations.show_language_switcher) === 1" :color="waiverConfigurations.text_color"/>
      </div>
    </div>

<!--    <div class="row mt-2 mr-2 justify-content-end text-right ">-->
<!--      <div class="col-12">-->
<!--        <base-button :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" v-if="!is_authenticated" link type="success" v-on:click="login()"><i class="tim-icons icon-single-02"></i> Login</base-button>-->
<!--        <base-button :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" v-if="!is_authenticated" link type="success" v-on:click="register()"><i class="tim-icons icon-laptop"></i> Register</base-button>-->
<!--        <base-button :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" v-if="is_authenticated" link type="success" v-on:click="toProfile()" class="mr-3"><i class="tim-icons icon-single-02"></i> Account</base-button>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container" v-show="!notFound">
      <div class="row">
        <div class="col-md-6 mt-5 mb-4 ml-auto mr-auto text-center">
          <img :height="waiverConfigurations.logo_height" :width="waiverConfigurations.logo_width" :style="{'object-fit': waiverConfigurations.logo_fit}" :src="waiverConfigurations.logo" alt="logo">
          <h4 :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" class="mt-3 description" v-if="currentStep === 0">
            {{waiverConfigurations.main_message}}
          </h4>
        </div>
      </div>

      <!--Step 1 - Choose your experience-->
      <div class="row justify-content-center text-center" v-if="currentStep === 0 && waiverConfigurations.display_section_titles">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}"> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
           {{ sections[0].name }}
          </span></h3>
        </div>
      </div>
<!--      Compact-->
      <div v-if="waiverConfigurations.is_compact && currentStep === 0">
        <div class="row justify-content-center text-center" v-if="!is_kiosk">
          <div class="col">
            <div class="row mb-1 justify-content-center"
                 :style="{'font-family': waiverConfigurations.font_family}">
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }"
                 v-if="showPrevious(current)" v-on:click="decrementDay(current)"
                 class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> &nbsp;  {{ $t('checkin.previous') }}
              </a>
              <base-input :secondary-color="waiverConfigurations.text_color_card"
                          class="mt-2" inputmode='none'>
                <el-date-picker :key="$i18n.locale" :editable="false"
                  :clearable="false"
                  class="date-field-themed"
                  :style="{'--date-field-color': waiverConfigurations.text_color}"
                  prefix-icon="' '"
                  :size="'small'"
                  type="date"
                  :placeholder="$t('checkin.selectDate')"
                  value-format="yyyy-MM-dd"
                  :format="day_of_week + ' ' + locale.date_format"
                  v-model="current"
                  @change="changeDate()"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </base-input>
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }"
                 v-on:click="incrementDay(current)"
                 class="btn btn-link btn-primary d-none d-sm-block">
                {{ $t('checkin.next') }} &nbsp;<i class="tim-icons icon-minimal-right"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="row justify-content-center" v-if="waiverConfigurations.multiple_games">
          <div class="col-lg-6 text-center">
            <base-button :disabled="checkInGames.length === 0" simple v-on:click="selectMultipleCompact()"
                         :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium',
                           'border-color': waiverConfigurations.text_color, 'width': '100%', 'font-size': 'large', 'font-weight': 'bold'}">
              <span v-if="checkInGames.length === 0"> {{ $t('checkin.selectGamesToCheckIn') }}  </span>
              <span v-if="checkInGames.length === 1"> {{ $t('checkin.checkInForOneGames') }} </span>
              <span v-if="checkInGames.length > 1"> {{ $t('checkin.checkInForXGames', { num: checkInGames.length}) }} </span>
              <i v-if="checkInGames.length > 0" :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-right ml-2"></i>
            </base-button>
          </div>
        </div>
        <div class="row mb-5 justify-content-center d-flex align-items-stretch" >
          <div class="col-lg-4 mt-3 col-md-4 col-sm-6 col-11" v-for="(game, index) in gameOptions" :key="index + 'G' + j">
            <card class="h-100" :style="{ 'background-color': waiverConfigurations.card_color}">
              <div slot="image" style="padding-bottom: 0px; height: 250px; margin-bottom: -50px">
                <el-carousel :arrow="getArrowSetting(gameImagesFor(game.game_images))" :autoplay="false" indicator-position="none" :interval="5000">
                  <el-carousel-item style="border-radius: 5px; width: 100%; height: 200px;"
                                    :style="{'background-color': item.background_color}" v-for="(item, index) in gameImagesFor(game.game_images)"
                                    :key="'CS' + index">
                    <div  style="border-radius: 5px; width: 100%; height: 200px; position: relative">
                      <img
                        :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')', 'left': item.x + 'px', 'top': item.y + 'px', 'object-fit':  imageFitInBox(item), 'height': '100%'}"
                        class="card-img"
                        style="position: absolute; transform-origin: center center; will-change: transform"
                        slot="image" v-twin-src="item.url"  alt="Card image cap"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="row">
                <div class="col text-center">
                  <h4 :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}" >{{game.name}}</h4>
                </div>
              </div>

              <!--   No data panel -->
              <div style="height:75%" v-if="game.slots.length <= 0">
                <div class="empty-bookings h-100" :style="{ 'font-family': waiverConfigurations.font_family_card,
                                  'border-color': waiverConfigurations.button_color,
                                  'color': waiverConfigurations.button_color }">
                        <span style="font-size: 2.1em">
                          <i class="tim-icons icon-calendar-60"></i>
                        </span>
                  <p :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}" class="mt-3">
                    {{ $t('checkin.noBookingsAvailable') }}
                  </p>
                </div>
              </div>
              <div class="row" style="margin-bottom: -30px; padding-left: 6px; padding-right: 6px">
                <div style="display: inline-flex; padding-left: 4px; padding-right: 4px" class="col-6 col-sm-6 col-lg-4 col-md-6" v-for="(s, i) in game.slots" :key="'S' + i" :ref="'el'+i">
                  <base-button v-if="!s.selected" style="margin-right: 0px; margin-left: 0px;  overflow-wrap: anywhere" :style="{ 'font-family': waiverConfigurations.font_family_card,
                                  'border-color': waiverConfigurations.button_color,
                                  'color': waiverConfigurations.button_color, 'width': '100%', 'padding-left': '5px',  'padding-right': '5px' }"

                                v-on:click="selectBookingCompactView(s, game)"
                                simple >
                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%"
                         :style="{ minHeight: hasBookedNames(game.slots) ? '2.75em' : null }">
                      <span>{{getDisplayTime(s)}}</span>
                      <span v-if="s.booked_name" style="font-size: 0.75em; opacity: 0.85; margin-top: 2px">{{s.booked_name}}</span>
                    </div>
                  </base-button>

                  <base-button v-if="s.selected" style="overflow-wrap: anywhere" :style="{ 'font-family': waiverConfigurations.font_family_card,
                                  'border-color': waiverConfigurations.button_color,
                                  'color': waiverConfigurations.button_color, 'width': '100%', 'padding-x': '5px', 'padding-left': '3px',  'padding-right': '3px' }"
                               v-on:click="unselectBookingCompactView(s)"
                               simple >
                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%"
                         :style="{ minHeight: hasBookedNames(game.slots) ? '2.75em' : null }">
                      <span><i style="font-weight: bolder" class="tim-icons icon-check-2 mr-1"></i> {{getDisplayTime(s)}}</span>
                      <span v-if="s.booked_name" style="font-size: 0.75em; opacity: 0.85; margin-top: 2px">{{s.booked_name}}</span>
                    </div>
                  </base-button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>


<!--      Not compact-->
      <div class="row justify-content-center" v-if="!waiverConfigurations.is_compact && currentStep === 0">
        <div class="col-lg-4 col-md-4 col-sm-6 col-11" v-for="game in gameOptions" :key="game.id">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div slot="image" class="card-img-top" style="padding-bottom: 0; height: 200px">
              <el-carousel :arrow="getArrowSetting(gameImagesFor(game.game_images))" :autoplay="false" indicator-position="none" :interval="5000">
                <el-carousel-item style="border-radius: 5px; width: 100%; height: 200px;"
                                  :style="{'background-color': item.background_color}" v-for="(item, index) in gameImagesFor(game.game_images)"
                                  :key="'CS' + index">
                  <div  style="border-radius: 5px; width: 100%; height: 200px; position: relative">
                    <img
                      :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')', 'left': item.x + 'px', 'top': item.y + 'px', 'object-fit':  imageFitInBox(item), 'height': '100%'}"
                      class="card-img"
                      style="position: absolute; transform-origin: center center; will-change: transform"
                      slot="image" v-twin-src="item.url"  alt="Card image cap"/>
<!--                    <img-->
<!--                         :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')', 'left': item.x + 'px', 'top': item.y + 'px', 'object-fit': 'cover', 'height': '100%', 'width': '100%'}"-->
<!--                         style="position: absolute; object-fit: cover; transform-origin: center center; will-change: transform;" :src="item.url">-->
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>

<!--            <img slot="image" class="card-img-top fixed-size-img" :src="game.img"  alt="Card image cap"/>-->
            <!--<h4 class="card-title">{{game.name}}</h4>-->
            <div class="row justify-content-center">
              <div class="col-lg-12 ">
                <base-button simple size="lg" v-on:click="selectGame(game)"
                             class="game-button"
                             :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }">
                  {{game.name}}</base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
<!--      Step 2 - Pick from available booking slots-->
      <div class="row justify-content-center text-center" v-if="currentStep === 1 && display.includes('Booking Date') && waiverConfigurations.display_section_titles">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}"> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
            <span class="mt-4">{{ sections[1].name }}</span>
          </span></h3>
        </div>

      </div>
      <div class="row" v-if="currentStep === 1 && display.includes('Booking Date')">
        <div class="col-lg-1 ml-4 col-2">
          <base-button
            :style="{ 'font-family': waiverConfigurations.font_family,
                        'border-color': waiverConfigurations.text_color,
                        'color': waiverConfigurations.text_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
            v-on:click="backButton()" link >
            <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
          </base-button>
        </div>
      </div>
      <div class="row justify-content-center text-center" v-if="currentStep === 1 && display.includes('Booking Date')">
        <div class="col">
          <div class="row mb-1 justify-content-center" :style="{'font-family': waiverConfigurations.font_family}" v-if="!is_kiosk">
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }" v-if="showPrevious(current)" v-on:click="decrementDay(current)"  class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> &nbsp; {{ $t('checkin.previous') }}
              </a>
              <base-input :secondary-color="waiverConfigurations.text_color_card"
                          class="mt-2" inputmode='none'>
                <el-date-picker :key="$i18n.locale" :editable="false"
                  :clearable="false"
                  class="date-field-themed"
                  :style="{'--date-field-color': waiverConfigurations.text_color}"
                  prefix-icon="' '"
                  :size="'small'"
                  type="date"
                  :placeholder="$t('checkin.selectDate')"
                  value-format="yyyy-MM-dd"
                  :format="day_of_week + ' ' + locale.date_format"
                  v-model="current"
                  @change="changeDate()"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </base-input>
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }"
                 v-on:click="incrementDay(current)"
                 class="btn btn-link btn-primary d-none d-sm-block">
                {{ $t('checkin.next') }} &nbsp;<i class="tim-icons icon-minimal-right"></i>
              </a>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 1 && display.includes('Booking Date')">
        <div class="col-10" v-if="noBookingsAvailable === true">
          <div class="font-icon-detail" :style="{'border': '1px solid ' + waiverConfigurations.text_color + ' !important'}">
              <span style="font-size: 3em">
                <i :style="{'color': waiverConfigurations.text_color}" class="fas fa-exclamation-triangle"></i>
              </span>
            <h4 :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" class="mt-3"> {{ $t('checkin.noAvailableBookings') }}</h4>
          </div>
        </div>
        <div class="col-lg-4 col-md-7 col-sm-7 col-10" v-for="booking in bookings" :key="booking.id">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">

            <div class="row justify-content-center">
              <div class="col-lg-12 ">
                <base-button simple size="lg" v-on:click="selectBookingDate(booking)"
                             class="game-button"
                             :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }">
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%"
                       :style="{ minHeight: hasBookedNames(bookings) ? '2.75em' : null }">
                    <span>{{getDisplayTime(booking)}}</span>
                    <span v-if="booking.booked_name" style="font-size: 0.75em; opacity: 0.85; margin-top: 2px">{{booking.booked_name}}</span>
                  </div>
                  </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!--      Step 3 - Select additional games-->
      <div class="row justify-content-center" v-if="currentStep === 2">
        <div class="col-lg-6 col-md-7 col-sm-7 col-12" :style="{'font-family': waiverConfigurations.font_family_card}">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div class="row justify-content-center">
              <div class="col-lg-12 text-center ">
                <p class="mb-3" :style="{ 'color': waiverConfigurations.text_color_card}">{{ $t('checkin.checkInForMultipleGames') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col">
                <base-button simple v-on:click="selectAdditionalGames()"
                             :style="{'font-family': waiverConfigurations.font_family_card, 'width': '100%',
                              'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color }">
                  {{ $t('checkin.yes') }}
                </base-button>
              </div>
              <div class="col">
                <base-button simple v-on:click="noAdditionalGames()"
                             :style="{'font-family': waiverConfigurations.font_family_card, 'width': '100%',
                               'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color }">
                  {{ $t('checkin.no') }}
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>


  <!--      Step 4:  Player info-->
      <returning-customer-gate
        v-if="currentStep === 3 && shouldShowGate"
        :api-location="apiLocation"
        :code="$route.params.company"
        waiver-type="traditional"
        :theme="waiverConfigurations"
        :date-mask="dateMask"
        :date-placeholder="datePlaceholder"
        :birthday-mode="birthdayMode"
        :date-format="locale.date_format"
        :first-day-of-week="locale.first_day_of_week"
        :default-country="country.code"
        @confirmed="onGateConfirmed"
        @declined="onGateDeclined" />
      <div class="row justify-content-center text-center" v-if="currentStep === 3 && !easyCheckin && !shouldShowGate && waiverConfigurations.display_section_titles &&
       (display.includes('First Name') || display.includes('Last Name') || display.includes('Email')
       || display.includes('Phone'))">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}"> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
           <span class="mt-4">{{ sections[2].name }}</span>
          </span></h3>
        </div>
      </div>
      <div :style="{'font-family': waiverConfigurations.font_family_card}" class="row justify-content-center" v-if="currentStep === 3 && !easyCheckin && !shouldShowGate &&
       (display.includes('First Name') || display.includes('Last Name') || display.includes('Email')
       || display.includes('Phone'))">
        <div class="col-lg-6">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div class="row mt-5 justify-content-center">
              <div class="col" v-if="display.includes('First Name')">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.firstName') }}
                  <span v-if="requiredFields.includes('First Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.first_name" :secondary-color="waiverConfigurations.text_color_card" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.firstName')"
                            v-model="user.first_name"></base-input>
              </div>
              <div class="col" v-if="display.includes('Last Name')">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.lastName') }}
                  <span v-if="requiredFields.includes('Last Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.last_name" :secondary-color="waiverConfigurations.text_color_card" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.lastName')"
                            v-model="user.last_name"></base-input>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col" v-if="display.includes('Birthday')">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.birthday') }}
                  <span v-if="requiredFields.includes('Birthday')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <birthday-input
                  :mode="birthdayMode"
                  :error="errs.birthday"
                  :text-color="waiverConfigurations.text_color_card"
                  :card-color="waiverConfigurations.card_color"
                  :date-mask="dateMask"
                  :date-placeholder="datePlaceholder"
                  :date-format="locale.date_format"
                  :first-day-of-week="locale.first_day_of_week"
                  v-model="user.birthday"
                ></birthday-input>
              </div>
              <div class="col" v-if="display.includes('Phone')">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.phone') }}
                  <span v-if="requiredFields.includes('Phone')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input
                  :secondary-color="waiverConfigurations.text_color_card"
                  :error="errs.phone || (user.phoneBlurred ? user.phoneValidationMessage : '')"
                  :input-style="{'color': waiverConfigurations.text_color_card}">
                  <phone-number-input :input-style="{'color': waiverConfigurations.text_color_card}" ref="phoneInput"
                                      v-model="user.phone" @phone-update="handlePhoneUpdate"
                                      :default-country="country.code || 'US'"
                                      @blur="user.phoneBlurred = true"
                  />
                </base-input>
              </div>
            </div>
            <div class="row" v-if="showSmsConsent">
              <div class="col">
                <sms-consent
                  :enabled="true"
                  :theme="waiverConfigurations"
                  :business-name="smsBusinessName"
                  :platform-name="smsPlatformName"
                  :privacy-url="smsPrivacyUrl"
                  :terms-url="smsTermsUrl"
                  :transactional-consent.sync="smsTransactionalConsent"
                  :marketing-consent.sync="smsMarketingConsent"
                  @consent-text="onSmsConsentText"
                />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col" v-if="display.includes('Email')">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.email') }}
                  <span v-if="requiredFields.includes('Email')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.email || (emailBlurred ? emailTypoWarning(user.email) : '')" :secondary-color="waiverConfigurations.text_color_card" :input-style="{'color': waiverConfigurations.text_color_card}" v-model="user.email" :placeholder="$t('checkin.email')" @blur="emailBlurred = true"></base-input>
              </div>
            </div>
            <div v-for="link in customFieldsForStep(3)" :key="'CF3_' + link.link_id" class="row mt-3">
              <div class="col">
                <!-- Type 2: text input -->
                <template v-if="link.type === 2">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :input-style="{'color': waiverConfigurations.text_color_card}"
                              :placeholder="link.label" />
                </template>
                <!-- Type 5: long text -->
                <template v-else-if="link.type === 5">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}">
                    <textarea class="form-control" rows="4"
                              :style="{'color': waiverConfigurations.text_color_card}"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :placeholder="link.label"></textarea>
                  </base-input>
                </template>
                <!-- Type 3: dropdown with optional follow-up field -->
                <template v-else-if="link.type === 3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ link.label }}
                        <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :error="errs.customFields[link.custom_field_id]"
                                  :secondary-color="waiverConfigurations.text_color_card"
                                  :placeholder="$t('checkin.select')">
                        <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                       :style="{'font-family': waiverConfigurations.font_family_card }"
                                       title-classes="form-group form-control"
                                       :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="waiverConfigurations.font_family_card"
                                       :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                          <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                             :style="{'font-family': waiverConfigurations.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"
                             @click.prevent="selectDropdown(link, opt)">
                            {{ getDropDownLabel(opt) }}
                          </a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                        <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :secondary-color="waiverConfigurations.text_color_card"
                                  :input-style="{'color': waiverConfigurations.text_color_card}"
                                  v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                    </div>
                  </div>
                </template>
                <!-- Type 1: checkbox with external links + policies -->
                <template v-else-if="link.type === 1">
                  <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                 :key="'CFCB_' + link.link_id + '_' + j"
                                 :border-color="waiverConfigurations.button_color"
                                 :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="customFieldResponses[link.custom_field_id]"
                                 simple size="sm">
                    <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                    <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                      <a v-on:click="recordInteraction(el)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                         target="_blank"
                         :href="el.link"> {{ el.link_text }}</a>
                    </span>
                    <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                      <a href="#"
                         v-on:click.prevent="openPolicy(p, link)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                    </span>
                    <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                  </base-checkbox>
                  <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                </template>
              </div>
            </div>
            <div class="row mt-3 mb-2 justify-content-center">
              <div class="col-lg-1 col-2" v-if="!is_walkin">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col">
                <base-button :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                  simple class="game-button" v-on:click="setUserData()">{{ $t('checkin.next') }}</base-button>
              </div>
            </div>

          </card>
        </div>
      </div>

      <!--      Step 5 - Minors-->
      <div class="row justify-content-center text-center" v-if="currentStep === 4 && waiverConfigurations.display_section_titles">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}" > <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
             <span class="mt-4">{{ sections[3].name }}</span>
          </span></h3>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 4 &&  has_minors == false">
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div class="row justify-content-center">
              <div :style="{'font-family': waiverConfigurations.font_family_card}" class="col-lg-12 col-12 text-center ">
                <p class="mb-3" :style="{'color': waiverConfigurations.text_color_card}">{{ waiverConfigurations.accompanying_children_text || $t('checkin.areYouAccompanyingChildren') }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col">
                <base-button :style="{'width': '100%', 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color}" simple  v-on:click="isMinor(1)">
                  {{ $t('checkin.yes') }}
                </base-button>

              </div>
              <div class="col">
                <base-button :style="{'width': '100%', 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color}" simple  v-on:click="isMinor(0)">
                  {{ $t('checkin.no') }}
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 4 && has_minors == true">
        <div class="col-lg-8" :style="{'font-family': waiverConfigurations.font_family_card}">
          <card :style="{ 'background-color': waiverConfigurations.card_color}" >
            <div class="row justify-content-between" v-for="(m, i) in minors" :key="'A' + i + x">
              <div class="col-10 col-lg-4" v-if="display.includes('Child First Name')" style="padding-right: 0px;">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.firstName') }}
                  <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}" v-if="requiredFields.includes('Child First Name')">*</span>
                </label>
                <base-input :error="m.error_first_name"
                            :secondary-color="waiverConfigurations.text_color_card"
                            :input-style="{'color': waiverConfigurations.text_color_card}"  :placeholder="$t('checkin.firstName')"
                            v-model="m.first_name"></base-input>
              </div>
              <div class="col-10 col-lg-4" v-if="display.includes('Child Last Name')" style="padding-right: 0px;">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.lastName') }}
                  <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}" v-if="requiredFields.includes('Child Last Name')">*</span>
                </label>
                <base-input :error="m.error_last_name" :secondary-color="waiverConfigurations.text_color_card" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.lastName')"
                            v-model="m.last_name"></base-input>
              </div>
              <div class="col-10 col-lg-3" v-if="display.includes('Child Birthday')" style="padding-right: 0px;">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.birthday') }}
                  <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}" v-if="requiredFields.includes('Child Birthday')">*</span>
                </label>
                <birthday-input
                  :mode="birthdayMode"
                  :error="m.error_birthday"
                  :text-color="waiverConfigurations.text_color_card"
                  :card-color="waiverConfigurations.card_color"
                  :date-mask="dateMask"
                  :date-placeholder="datePlaceholder"
                  :date-format="locale.date_format"
                  :first-day-of-week="locale.first_day_of_week"
                  v-model="m.birthday"
                ></birthday-input>
              </div>
              <div class="col-1 mr-4 mr-lg-0" >
                <i :style="{ 'color': waiverConfigurations.button_color }" v-on:click="removeChild(i)"
                   style="cursor: pointer; margin-top: 37px; padding-left: 0px"
                   class="tim-icons icon-simple-remove"></i>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <base-button :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }" simple v-on:click="addMinor()">
                  {{ $t('checkin.addAnotherChild') }}
                </base-button>
              </div>
            </div>
            <div class="row mb-2" v-if="waiverConfigurations.show_participation_field">
              <div class="col">
                <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                :check-mark-color="waiverConfigurations.card_color"
                               v-model="not_participating">
                  <span :style="{'color': waiverConfigurations.text_color_card}">{{ waiverConfigurations.participation_field_text }}</span>
                </base-checkbox>
              </div>
            </div>
            <div v-for="link in customFieldsForStep(4)" :key="'CF4_' + link.link_id" class="row mt-3">
              <div class="col">
                <!-- Type 2: text input -->
                <template v-if="link.type === 2">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :input-style="{'color': waiverConfigurations.text_color_card}"
                              :placeholder="link.label" />
                </template>
                <!-- Type 5: long text -->
                <template v-else-if="link.type === 5">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}">
                    <textarea class="form-control" rows="4"
                              :style="{'color': waiverConfigurations.text_color_card}"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :placeholder="link.label"></textarea>
                  </base-input>
                </template>
                <!-- Type 3: dropdown with optional follow-up field -->
                <template v-else-if="link.type === 3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ link.label }}
                        <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :error="errs.customFields[link.custom_field_id]"
                                  :secondary-color="waiverConfigurations.text_color_card"
                                  :placeholder="$t('checkin.select')">
                        <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                       :style="{'font-family': waiverConfigurations.font_family_card }"
                                       title-classes="form-group form-control"
                                       :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="waiverConfigurations.font_family_card"
                                       :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                          <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                             :style="{'font-family': waiverConfigurations.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"
                             @click.prevent="selectDropdown(link, opt)">
                            {{ getDropDownLabel(opt) }}
                          </a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                        <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :secondary-color="waiverConfigurations.text_color_card"
                                  :input-style="{'color': waiverConfigurations.text_color_card}"
                                  v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                    </div>
                  </div>
                </template>
                <!-- Type 1: checkbox with external links + policies -->
                <template v-else-if="link.type === 1">
                  <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                 :key="'CFCB_' + link.link_id + '_' + j"
                                 :border-color="waiverConfigurations.button_color"
                                 :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="customFieldResponses[link.custom_field_id]"
                                 simple size="sm">
                    <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                    <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                      <a v-on:click="recordInteraction(el)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                         target="_blank"
                         :href="el.link"> {{ el.link_text }}</a>
                    </span>
                    <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                      <a href="#"
                         v-on:click.prevent="openPolicy(p, link)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                    </span>
                    <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                  </base-checkbox>
                  <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                </template>
              </div>
            </div>
            <div class="row mt-3 mb-2 justify-content-center">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col">
                <base-button :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                             class="game-button" simple type="success" v-on:click="setMinorData()">{{ $t('checkin.next') }}</base-button>
              </div>
            </div>
          </card>
        </div>
      </div>


      <!--      Step 6 - Signature and waiver text-->
      <div class="row justify-content-center text-center" v-if="currentStep === 5 && waiverConfigurations.display_section_titles">
        <div class="col" :style="{'font-family': waiverConfigurations.font_family}">
          <h3> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
            <span class="mt-4">{{ sections[4].name }}</span>
          </span></h3>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 5">
        <div class="col-lg-8 col-md-10 col-sm-12 col-12" :style="{'font-family': waiverConfigurations.font_family_card}">
          <card :style="{ 'background-color': waiverConfigurations.card_color}"
                footer-classes="text-center mb-3 mt-3"
          >
            <span v-html="waiverConfigurations.waiver_text"></span>
<!--            <textarea :style="{'background-color': 'white'}" v-if="waiverConfigurations.waiver_text" disabled rows="30" v-model="waiverConfigurations.waiver_text"></textarea>-->
            <div class="mt-2" v-if="waiverConfigurations.external_link">
              <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                             :check-mark-color="waiverConfigurations.card_color"
                             v-model="conditions">
               <span :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.agreeToToS') }}
                 <a :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}" target="_blank" :href="waiverConfigurations.external_link">{{ $t('checkin.termsAndConditions') }}</a>.</span>

              </base-checkbox>
              <p :style="{'font-family': waiverConfigurations.font_family_card, 'color': '#ec250d'}" class="small ml-4" v-if="errs.conditions">
                {{ errs.conditions }}</p>
            </div>
            <div v-if="display.includes('Signature')" class="row mt-3 justify-content-between">
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <h6 :style="{'color': waiverConfigurations.text_color_card}" class="mt-3">{{ $t('checkin.signature') }}</h6>
              </div>
              <div class="mr-3 ml-3">
                <base-button :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color,'color': waiverConfigurations.button_color}" size="sm" align="left" simple v-on:click="clearSignature()" type="secondary">
                  {{ $t('checkin.clearSignature') }}
                </base-button>
              </div>
            </div>

            <div class="row" v-if="display.includes('Signature')">

              <div class=" col-lg-12">
                <VueSignaturePad :custom-style="background_sig" :style="{'border-color': waiverConfigurations.button_color}" class="sig-pad" height="200px" ref="signaturePad" />
                <p :style="{'font-family': waiverConfigurations.font_family_card, 'color': '#ec250d'}" class="small" v-if="errs.signature">
                  {{ errs.signature }}</p>
              </div>
            </div>
            <div v-if="display.includes('Photo Opt Out')" class="row">
              <div class="col">
                <base-checkbox  :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                :check-mark-color="waiverConfigurations.card_color" class="ml-1" v-model="picture_optout">
                  <span :style="{'color': waiverConfigurations.text_color_card}">{{ optInLabel('Photo Opt Out') }}</span>
                </base-checkbox>
              </div>
            </div>
            <div v-if="display.includes('Email Opt Out')" class="row">
              <div class="col-12 col-lg-12">
                <base-checkbox  :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                :check-mark-color="waiverConfigurations.card_color" class="ml-1" v-model="email_optout">
                  <span :style="{'color': waiverConfigurations.text_color_card}">{{ optInLabel('Email Opt Out') }}</span>
                </base-checkbox>
              </div>
            </div>
            <div v-for="link in customFieldsForStep(5)" :key="'CF5_' + link.link_id" class="row mt-3">
              <div class="col">
                <!-- Type 2: text input -->
                <template v-if="link.type === 2">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :input-style="{'color': waiverConfigurations.text_color_card}"
                              :placeholder="link.label" />
                </template>
                <!-- Type 5: long text -->
                <template v-else-if="link.type === 5">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}">
                    <textarea class="form-control" rows="4"
                              :style="{'color': waiverConfigurations.text_color_card}"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :placeholder="link.label"></textarea>
                  </base-input>
                </template>
                <!-- Type 3: dropdown with optional follow-up field -->
                <template v-else-if="link.type === 3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ link.label }}
                        <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :error="errs.customFields[link.custom_field_id]"
                                  :secondary-color="waiverConfigurations.text_color_card"
                                  :placeholder="$t('checkin.select')">
                        <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                       :style="{'font-family': waiverConfigurations.font_family_card }"
                                       title-classes="form-group form-control"
                                       :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="waiverConfigurations.font_family_card"
                                       :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                          <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                             :style="{'font-family': waiverConfigurations.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"
                             @click.prevent="selectDropdown(link, opt)">
                            {{ getDropDownLabel(opt) }}
                          </a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                        <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :secondary-color="waiverConfigurations.text_color_card"
                                  :input-style="{'color': waiverConfigurations.text_color_card}"
                                  v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                    </div>
                  </div>
                </template>
                <!-- Type 1: checkbox with external links + policies -->
                <template v-else-if="link.type === 1">
                  <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                 :key="'CFCB_' + link.link_id + '_' + j"
                                 :border-color="waiverConfigurations.button_color"
                                 :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="customFieldResponses[link.custom_field_id]"
                                 simple size="sm">
                    <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                    <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                      <a v-on:click="recordInteraction(el)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                         target="_blank"
                         :href="el.link"> {{ el.link_text }}</a>
                    </span>
                    <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                      <a href="#"
                         v-on:click.prevent="openPolicy(p, link)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                    </span>
                    <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                  </base-checkbox>
                  <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                </template>
              </div>
            </div>
            <div class="row mt-3 mb-2 justify-content-end">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col">
                <base-button :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                         simple class="game-button" v-on:click="setSignatureData()">{{ $t('checkin.next') }}</base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!--      Step 7 - Marketing-->
      <div class="row justify-content-center text-center" v-if="currentStep === 6 && waiverConfigurations.display_section_titles">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}"> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
            <span class="mt-4">{{ sections[5].name }}</span>
          </span></h3>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 6">
        <div class="col-lg-6 col-md-7 col-sm-7 col-12" :style="{'font-family': waiverConfigurations.font_family_card}">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div v-if="display.includes('Source')" class="row">
              <div class="col">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.howDidYouHearAboutUs') }}
                  <span v-if="requiredFields.includes('Source')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.source" :secondary-color="waiverConfigurations.text_color_card" :placeholder="$t('checkin.select')">
                  <base-dropdown :style="{'font-family': waiverConfigurations.font_family_card }"
                                 title-classes="form-group form-control" :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                 :font-family="waiverConfigurations.font_family_card"
                                 :title="selectedSource.label"
                  >
                    <a v-for="(s, i) in sources"  :style="{'font-family': waiverConfigurations.font_family_card }"
                       style="white-space: normal; overflow-wrap: break-word;"
                       class="dropdown-item" href="#" :key="'DOJ' + i" v-on:click="selectedSource = s">
                      {{ s.label }}</a>
                  </base-dropdown>
                </base-input>
              </div>
              <div v-if="selectedSource.label === 'Other'" class="col">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.pleaseSpecify') }}
                </label>
                <base-input :secondary-color="waiverConfigurations.text_color_card"
                            v-model="otherSource" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.source')"
                ></base-input>
              </div>
            </div>

            <div v-if="display.includes('Experience')" class="row">
              <div class="col">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.experience') }}
                  <span v-if="requiredFields.includes('Experience')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.experience" :secondary-color="waiverConfigurations.text_color_card" :placeholder="$t('checkin.select')">
                  <base-dropdown :style="{'font-family': waiverConfigurations.font_family_card }"
                                 title-classes="form-group form-control" :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                 :font-family="waiverConfigurations.font_family_card"
                                 :title="selectedExperience.label"
                  >
                    <a v-for="(e, i) in experiences"  :style="{'font-family': waiverConfigurations.font_family_card }"
                       style="white-space: normal; overflow-wrap: break-word;"
                       class="dropdown-item" href="#" :key="'EXX' + i" v-on:click="selectedExperience = e">
                      {{ e.label }}</a>
                  </base-dropdown>
                </base-input>
              </div>
            </div>

            <div v-if="display.includes('Location')" class="row">
              <div class="col-lg-4">
                <label :style="{'color': waiverConfigurations.text_color_card}">{{ $t('checkin.whereAreYouFrom') }}
                  <span v-if="requiredFields.includes('Location')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                </label>
                <base-input :error="errs.location.city" :secondary-color="waiverConfigurations.text_color_card"
                            style="margin-bottom: 0px;" :placeholder="$t('checkin.city')" v-model="city" :input-style="{'color': waiverConfigurations.text_color_card}">
                </base-input>
              </div>
              <div class="col-lg-4">
                <label :style="{'color': waiverConfigurations.text_color_card}"> &nbsp;
                </label>
                <base-input :error="errs.location.state" :secondary-color="waiverConfigurations.text_color_card"
                            style="margin-bottom: 0px;" :placeholder="state_placeholder" v-model="selectedState" :input-style="{'color': waiverConfigurations.text_color_card}">
                </base-input>
              </div>
              <div class="col-lg-4">
                <label :style="{'color': waiverConfigurations.text_color_card}"> &nbsp;
                </label>
                <base-input :error="errs.location.zip" :secondary-color="waiverConfigurations.text_color_card" maxlength="10"
                            style="margin-bottom: 0px;" :placeholder="zip_placeholder" v-model="zip" :input-style="{'color': waiverConfigurations.text_color_card}">
                </base-input>
              </div>
            </div>

            <div v-for="link in customFieldsForStep(6)" :key="'CF6_' + link.link_id" class="row mt-3">
              <div class="col">
                <!-- Type 2: text input -->
                <template v-if="link.type === 2">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :input-style="{'color': waiverConfigurations.text_color_card}"
                              :placeholder="link.label" />
                </template>
                <!-- Type 5: long text -->
                <template v-else-if="link.type === 5">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}">
                    <textarea class="form-control" rows="4"
                              :style="{'color': waiverConfigurations.text_color_card}"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :placeholder="link.label"></textarea>
                  </base-input>
                </template>
                <!-- Type 3: dropdown with optional follow-up field -->
                <template v-else-if="link.type === 3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ link.label }}
                        <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :error="errs.customFields[link.custom_field_id]"
                                  :secondary-color="waiverConfigurations.text_color_card"
                                  :placeholder="$t('checkin.select')">
                        <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                       :style="{'font-family': waiverConfigurations.font_family_card }"
                                       title-classes="form-group form-control"
                                       :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="waiverConfigurations.font_family_card"
                                       :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                          <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                             :style="{'font-family': waiverConfigurations.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"
                             @click.prevent="selectDropdown(link, opt)">
                            {{ getDropDownLabel(opt) }}
                          </a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                        <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :secondary-color="waiverConfigurations.text_color_card"
                                  :input-style="{'color': waiverConfigurations.text_color_card}"
                                  v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                    </div>
                  </div>
                </template>
                <!-- Type 1: checkbox with external links + policies -->
                <template v-else-if="link.type === 1">
                  <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                 :key="'CFCB_' + link.link_id + '_' + j"
                                 :border-color="waiverConfigurations.button_color"
                                 :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="customFieldResponses[link.custom_field_id]"
                                 simple size="sm">
                    <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                    <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                      <a v-on:click="recordInteraction(el)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                         target="_blank"
                         :href="el.link"> {{ el.link_text }}</a>
                    </span>
                    <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                      <a href="#"
                         v-on:click.prevent="openPolicy(p, link)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                    </span>
                    <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                  </base-checkbox>
                  <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                </template>
              </div>
            </div>

            <div class="row mt-3 justify-content-center">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col text-center">
                <base-button simple  v-on:click="setMarketingData()"
                             class="game-button"
                             :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }">
                  <span class="ml-1 mt-1">{{ $t('checkin.next') }}</span>
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>


    <!--      Step 7 - Confirm (with optional Final-step custom fields rendered above) -->
      <div class="row justify-content-center text-center" v-if="currentStep === 7 && waiverConfigurations.display_section_titles && sections[6] && customFieldsForStep(7).length > 0">
        <div class="col">
          <h3 :style="{'font-family': waiverConfigurations.font_family}"> <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
            <span class="mt-4">{{sections[6].name}}</span>
          </span></h3>
        </div>
      </div>
      <div class="row justify-content-center" v-if="currentStep === 7">
        <div class="col-lg-6 col-md-7 col-sm-7 col-12" :style="{'font-family': waiverConfigurations.font_family_card}">
          <card :style="{ 'background-color': waiverConfigurations.card_color}">
            <div v-for="link in customFieldsForStep(7)" :key="'CF7_' + link.link_id" class="row mt-3">
              <div class="col">
                <!-- Type 2: text input -->
                <template v-if="link.type === 2">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :input-style="{'color': waiverConfigurations.text_color_card}"
                              :placeholder="link.label" />
                </template>
                <!-- Type 5: long text -->
                <template v-else-if="link.type === 5">
                  <label :style="{'color': waiverConfigurations.text_color_card}">
                    {{ link.label }}
                    <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :error="errs.customFields[link.custom_field_id]"
                              :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}">
                    <textarea class="form-control" rows="4"
                              :style="{'color': waiverConfigurations.text_color_card}"
                              v-model="customFieldResponses[link.custom_field_id]"
                              :placeholder="link.label"></textarea>
                  </base-input>
                </template>
                <!-- Type 3: dropdown with optional follow-up field -->
                <template v-else-if="link.type === 3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ link.label }}
                        <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :error="errs.customFields[link.custom_field_id]"
                                  :secondary-color="waiverConfigurations.text_color_card"
                                  :placeholder="$t('checkin.select')">
                        <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                       :style="{'font-family': waiverConfigurations.font_family_card }"
                                       title-classes="form-group form-control"
                                       :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="waiverConfigurations.font_family_card"
                                       :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                          <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                             :style="{'font-family': waiverConfigurations.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"
                             @click.prevent="selectDropdown(link, opt)">
                            {{ getDropDownLabel(opt) }}
                          </a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                      <label :style="{'color': waiverConfigurations.text_color_card}">
                        {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                        <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                      </label>
                      <base-input :secondary-color="waiverConfigurations.text_color_card"
                                  :input-style="{'color': waiverConfigurations.text_color_card}"
                                  v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                    </div>
                  </div>
                </template>
                <!-- Type 1: checkbox with external links + policies -->
                <template v-else-if="link.type === 1">
                  <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                 :key="'CFCB_' + link.link_id + '_' + j"
                                 :border-color="waiverConfigurations.button_color"
                                 :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="customFieldResponses[link.custom_field_id]"
                                 simple size="sm">
                    <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                    <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                      <a v-on:click="recordInteraction(el)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                         target="_blank"
                         :href="el.link"> {{ el.link_text }}</a>
                    </span>
                    <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                      <a href="#"
                         v-on:click.prevent="openPolicy(p, link)"
                         :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                    </span>
                    <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                  </base-checkbox>
                  <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                </template>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-lg-12 text-center">
                <p :style="{'color': waiverConfigurations.text_color_card}" class="mb-3">{{ $t('checkin.confirmText') }}</p>
              </div>
            </div>
            <div class="checkin-summary" v-if="checkInGames.length > 0">
              <div class="checkin-summary-row" v-for="(c, i) in checkInGames" :key="'C' + i"
                   :style="{'color': waiverConfigurations.text_color_card}">
                <div v-if="checkInThumb(c.game)" class="checkin-summary-thumb"
                     :style="{'background-color': checkInThumb(c.game).background_color}">
                  <img v-twin-src="checkInThumb(c.game).url" :alt="c.game.name"/>
                </div>
                <div class="checkin-summary-info">
                  <span class="checkin-summary-name">{{c.game.name}}</span>
                  <span class="checkin-summary-when">
                    {{getDayOfWeek( c.booking.booking_date)}} {{getFormattedDate(locale.date_format, c.booking.booking_date)}}
                    &middot; {{getDisplayTime(c.booking)}}
                  </span>
                </div>
                <!-- The last remaining slot cannot be removed: a booked check-in needs at least one. -->
                <button v-if="checkInGames.length > 1" type="button" class="checkin-summary-remove"
                        :style="{'color': waiverConfigurations.button_color}"
                        :aria-label="$t('checkin.removeSlot')" :title="$t('checkin.removeSlot')"
                        v-on:click="removeCheckInGame(i)">
                  <i class="tim-icons icon-simple-remove"></i>
                </button>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-lg-1 col-2">
                <base-button
                  :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                  v-on:click="backButton()" link >
                  <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                </base-button>
              </div>
              <div class="col text-center">
                <base-button simple  v-on:click="confirmCheckin()" :disabled="disabled"
                             class="game-button"
                             :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }">
                  <span class="ml-1 mt-1">{{ $t('checkin.confirm') }}</span>
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>

    <!-- Custom field policy modal (opened by policy buttons inside checkbox custom fields) -->
    <modal :show.sync="modals.policy" id="cfPolicyModal"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card v-if="selectedPolicy"
            :style="{ 'background-color': waiverConfigurations.background_color}"
            header-classes="bg-white pb-5"
            class="border-0 mb-0">
        <p :style="{'color': waiverConfigurations.text_color}" v-html="selectedPolicy.policy"></p>
        <div class="row mt-3 justify-content-center">
          <div class="col text-center">
            <base-button :style="{ 'width': '100%', 'font-family': waiverConfigurations.font_family_card,
                          'border-color': waiverConfigurations.text_color, 'color': waiverConfigurations.text_color }"
                         simple
                         v-on:click="agreeToPolicy()">{{ $t('book.iAgree') || 'I agree' }}</base-button>
          </div>
        </div>
      </card>
    </modal>

    <!-- Dropdown option popup (opened when a selected option has has_popup + description) -->
    <modal :show.sync="modals.dropdown_popup"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card v-if="popupOption"
            :style="{ 'background-color': waiverConfigurations.background_color}"
            header-classes="bg-white pb-5"
            class="border-0 mb-0">
        <h4 :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color}">{{ popupOption.name }}</h4>
        <div :style="{'color': waiverConfigurations.text_color, 'font-family': waiverConfigurations.font_family_card}" v-html="popupOption.description"></div>
        <div class="row mt-3 justify-content-center">
          <div class="col text-center">
            <base-button :style="{ 'width': '100%', 'font-family': waiverConfigurations.font_family_card,
                          'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                         simple
                         v-on:click="acknowledgeDropdownPopup()">OK</base-button>
          </div>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import {API_LOCATION} from 'src/api-config'
import {DatePicker, Carousel, CarouselItem} from 'element-ui'
import NotFoundPage from "../../pages/GeneralViews/NotFoundPage";
const axios = require('axios')
import {displayTime, formattedDate, dayOfWeek} from '/src/plugins/dateFormatter'
import {Auth} from "aws-amplify";
import { parseGameImages, MOBILE_BREAKPOINT } from '@/util/gameImages'
import gameImageOrientation from '@/mixins/gameImageOrientation'
import swal from "sweetalert2";
import _ from 'lodash'
import countries from "@/assets/countries.json";
import moment from "moment"
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import SMSConsent from '@/components/SMSConsent.vue';
import { getSmsConsentVenue, SMS_PLATFORM_NAME } from '@/util/smsConsent';
import ReturningCustomerGate from '@/components/ReturningCustomerGate.vue';
import BirthdayInput from '@/components/BirthdayInput.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { applyPageLocale } from '@/i18n';
import { isValidEmail } from '@/util/emailValidator';
import emailTypoWarning from '@/mixins/emailTypoWarning';
import { syncServerNow, getNow } from '@/util/serverTime';
import { inputBorderColor } from '@/util/bookingTheme';
import { isValidIsoDate, ageFromIsoDate } from '@/util/birthdayDate';

export default {
  name: "Waiver",
  mixins: [gameImageOrientation, emailTypoWarning],
  components: {
    NotFoundPage,
    [DatePicker.name]: DatePicker,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    PhoneNumberInput,
    // Explicit kebab key: Vue resolves <sms-consent> to "SmsConsent", which
    // would not match a bare "SMSConsent" registration.
    'sms-consent': SMSConsent,
    ReturningCustomerGate,
    BirthdayInput,
    LanguageSwitcher
  },
  watch: {
    gameOptions() {
      if (!Array.isArray(this.gameOptions)) return
      this.gameOptions.forEach(g => this.probeImageOrientation(this.gameImagesFor(g.game_images)))
    }
  },

  data() {
    return {
      // A2P 10DLC opt-in. Both default false: carriers reject any campaign
      // whose consent box is pre-checked, so never seed these.
      smsTransactionalConsent: false,
      smsMarketingConsent: false,
      smsConsentText: null,
      refreshIntervalId: null,
      windowWidth: window.innerWidth,
      is_kiosk: false,
      is_walkin: false,
      not_participating: false,
      x: 0,
      j: 0,
      state_placeholder: 'State',
      country: '',
      countries: countries.countries,
      background_sig: { 'background-color': 'white'},
      loading: false,
      locale: '',
      has_minors: false,
      bookings: '',
      day_of_week: '',
      noBookingsAvailable: false,
      picture_optout: false,
      email_optout: false,
      selectedBooking: '',
      selectedGame: '',
      checkInGames: [],
      notFound: '',
      currentStep: 0,
      gameOptions: '',
      waiverConfigurations: '',
      conditions: false,
      current: '',
      fields: [],
      sections: [],
      customFieldLinks: [],
      customFieldResponses: {},
      display: [],
      signature: '',
      selectedExperience: '',
      selectedSource: '',
      otherSource: '',
      selectedState: '',
      city: '',
      zip: '',
      disabled: false,
      experiences: [
        {
          value: this.$t('checkin.exp.beginner'),
          label: this.$t('checkin.exp.beginnerDesc'),
        },
        {
          value: this.$t('checkin.exp.intermediate'),
          label: this.$t('checkin.exp.intermediateDesc'),
        },
        {
          value: this.$t('checkin.exp.expert'),
          label: this.$t('checkin.exp.expertDesc'),
        },
        {
          value: this.$t('checkin.exp.master'),
          label: this.$t('checkin.exp.masterDesc'),
        },
        {
          value: this.$t('checkin.exp.grandmaster'),
          label: this.$t('checkin.exp.grandmasterDesc'),
        }
      ],
      sources: [
        {
          value: 'Google',
          label: 'Google',
        },
        {
          value: 'Instagram',
          label: 'Instagram',
        },
        {
          value: 'Facebook',
          label: 'Facebook',
        },
        {
          value: 'Yelp',
          label: 'Yelp',
        },
        {
          value: this.$t('checkin.sources.wordOfMouth'),
          label: this.$t('checkin.sources.wordOfMouth'),
        },
        {
          value: this.$t('checkin.sources.other'),
          label: this.$t('checkin.sources.other'),
        },
      ],
      emailBlurred: false,
      user: {
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        birthday: '',
        phoneE164: '',
        phoneValidationStatus: 'valid',
        phoneValidationMessage: '',
        phoneBlurred: false
      },
      minors: [{
        first_name: '',
        last_name: '',
        birthday: ''
      }],
      errs: {
        email: '',
        first_name: '',
        last_name: '',
        birthday: '',
        phone: '',
        signature: '',
        conditions: '',
        source: '',
        location: {
          city: '',
          state: '',
          zip: ''
        },
        experience: '',
        customFields: {},
      },
      requiredFields: [],
      datePlaceholder: 'MM/DD/YYYY',
      dateMask: '##/##/####',
      modals: { policy: false, dropdown_popup: false },
      selectedCf: null,
      selectedPolicy: null,
      popupOption: null,
      gateResolved: false,
      easyCheckin: false,
      apiLocation: API_LOCATION,
    }
  },
  computed: {
    smsConsentVenue() {
      return getSmsConsentVenue(this.$route.params.company);
    },
    // Only where a phone number is actually collected on this waiver, and only
    // for venues registered for A2P messaging.
    showSmsConsent() {
      if (!this.display || this.display.indexOf('Phone') === -1) return false;
      return this.smsConsentVenue !== null;
    },
    // Registered legal business name, not the display name: a mismatch against
    // the brand registration is what Twilio error 30927 flags on review.
    smsBusinessName() {
      return this.smsConsentVenue ? this.smsConsentVenue.businessName : '';
    },
    smsPlatformName() {
      return SMS_PLATFORM_NAME;
    },
    smsPrivacyUrl() {
      return this.smsConsentVenue ? this.smsConsentVenue.privacyUrl : '';
    },
    smsTermsUrl() {
      return this.smsConsentVenue ? this.smsConsentVenue.termsUrl : '';
    },
    shouldShowGate() {
      return !this.gateResolved && this.waiverConfigurations && Number(this.waiverConfigurations.allow_easy_checkin) === 1
    },
    birthdayMode() {
      return this.waiverConfigurations.birthday_input_style || 'typed'
    },
    pickerOptions() {
      return {
        disabledDate: (time) => this.disabledDates(time, this.current),
        // group setting is 0-6 (Sunday=0, FullCalendar convention); Element UI wants 1-7 (Sunday=7)
        firstDayOfWeek: this.locale.first_day_of_week === 0 ? 7 : this.locale.first_day_of_week
      };
    },
    today(){
      return new Date()
    },
    // Localized term for the postal code field, driven by the venue's country
    // (e.g. "Zip" in the US, "Postal code" in Canada, "Postcode" in the UK).
    zip_placeholder(){
      return (this.country && this.country.zip_label) || 'Zip'
    },
  },
  methods: {
    // Verbatim wording the customer saw, stored alongside the consent row so a
    // later dispute is answered with what was actually shown, not with whatever
    // the current build renders.
    onSmsConsentText(snapshot) {
      this.smsConsentText = snapshot
    },
    onGateConfirmed({ email, partialUser }) {
      this.user.email = email
      if (partialUser.first_name) this.user.first_name = partialUser.first_name
      if (partialUser.last_name) this.user.last_name = partialUser.last_name
      if (partialUser.phone) {
        this.user.phone = partialUser.phone
        this.user.phoneE164 = partialUser.phone
      }
      if (partialUser.birthday) {
        this.user.birthday = partialUser.birthday
        this.user.formatted_birthday = this.validateBirthdayValue(partialUser.birthday).validDate
      }
      this.easyCheckin = true
      this.gateResolved = true
      this.$nextTick(() => this.setUserData())
    },
    onGateDeclined() {
      this.easyCheckin = false
      this.gateResolved = true
    },
    getOptInField(name){
      if(!Array.isArray(this.fields)) return null
      return this.fields.find(f => f.name === name) || null
    },
    isOptInMode(name){
      const field = this.getOptInField(name)
      return field ? !!field.is_optin : false
    },
    optInLabel(name){
      const field = this.getOptInField(name)
      if(field && field.label) return field.label
      const isOptin = field ? !!field.is_optin : false
      if(name === 'Email Opt Out'){
        return isOptin ? this.$t('checkin.consentToMailingLists') : this.$t('checkin.doNotIncludeInMailingLists')
      }
      if(name === 'Photo Opt Out'){
        return isOptin ? this.$t('checkin.consentToSharePhotos') : this.$t('checkin.doNotSharePhotos')
      }
      return ''
    },
    // Map a customer-facing kiosk step to the corresponding admin section's array index.
    // Sections array order from getWaiverConfigurations: welcome, date, user_info, minors, signature, marketing.
    // Customer step 2 ("select multiple games") doesn't have its own admin section — it's part of date selection.
    stepToSectionIndex(step){
      const map = { 0: 0, 1: 1, 3: 2, 4: 3, 5: 4, 6: 5, 7: 6 }
      return map[step]
    },
    // Resolve the actual waiver_section position for a step at runtime.
    // The position values vary per admin (some setups use 1-6, others 2-7), so hardcoding is wrong —
    // we have to look up sections[i].position dynamically.
    sectionPositionForStep(step){
      const idx = this.stepToSectionIndex(step)
      if (idx == null || !Array.isArray(this.sections) || !this.sections[idx]) return null
      return Number(this.sections[idx].position)
    },
    customFieldsForStep(step){
      const pos = this.sectionPositionForStep(step)
      if (pos == null) return []
      return this.customFieldsForSection(pos)
    },
    validateCustomFieldsForStep(step){
      const pos = this.sectionPositionForStep(step)
      if (pos == null) return 0
      return this.validateCustomFieldsForSection(pos)
    },
    customFieldsForSection(position){
      return this.customFieldLinks
        .filter(l => Number(l.waiver_section) === Number(position))
        .filter(l => this.isFieldVisible(l))
        .sort((a, b) => (a.position || 0) - (b.position || 0))
    },
    isFieldVisible(link){
      const allowed_games = link.visibility_conditions ? (typeof link.visibility_conditions === 'string' ? JSON.parse(link.visibility_conditions) : link.visibility_conditions) : []
      let event_scope
      if (allowed_games.length > 0) event_scope = 'specific'
      else if (link.visibility) event_scope = 'none'
      else event_scope = 'all'
      // Checkin's selected bookings live in `checkInGames` (each shaped `{game, booking}`),
      // not in `this.bookings` (which is the available-slot list for selection).
      // Waivers have no cart context, so the gift card axis cannot match.
      const selected = (this.checkInGames || []).filter(cg => cg && cg.game)
      for (const cg of selected) {
        const gameId = cg.game.id || cg.game.game_id
        if (gameId == null) continue
        if (event_scope === 'all') return true
        if (event_scope === 'specific' && _.find(allowed_games, {id: gameId})) return true
      }
      return false
    },
    validateCustomFieldsForSection(position){
      let errors = 0
      for(const link of this.customFieldsForSection(position)){
        if(!link.required) continue
        const val = this.customFieldResponses[link.custom_field_id]
        let isMissing = false
        if(link.type === 1){
          isMissing = !val
        } else if(link.type === 3){
          // Type 3 stores the option object — must have .name. If has_follow_up_field, follow_up_response is also required.
          if(!val || !val.name){
            isMissing = true
          } else if(val.has_follow_up_field && (val.follow_up_response == null || String(val.follow_up_response).trim() === '')){
            isMissing = true
          }
        } else {
          isMissing = (val == null || String(val).trim() === '')
        }
        if(isMissing){
          this.$set(this.errs.customFields, link.custom_field_id, 'Required')
          errors++
        } else {
          this.$set(this.errs.customFields, link.custom_field_id, '')
        }
      }
      return errors
    },
    handleCustomFieldInput(link){
      // Mirrors CreateBooking.vue: if the field requires interaction with linked policies/external links,
      // gate the checkbox response on each one having user_interaction = 1.
      let ready = false
      if(link.interaction_required){
        let totalCount = 0
        let interactiveCount = 0
        const links = link.external_links || []
        for(const el of links){
          totalCount++
          if(el.user_interaction){ interactiveCount++ }
        }
        const policies = link.policies || []
        for(const p of policies){
          totalCount++
          if(p.user_interaction){ interactiveCount++ }
        }
        if(totalCount === interactiveCount){
          ready = true
          this.$set(this.errs.customFields, link.custom_field_id, '')
        } else {
          ready = false
          this.$set(this.customFieldResponses, link.custom_field_id, false)
          this.$set(this.errs.customFields, link.custom_field_id, 'Please read all attached policies')
        }
        this.j++
      } else {
        ready = true
      }
      return ready
    },
    recordInteraction(item){
      this.$set(item, 'user_interaction', 1)
    },
    openPolicy(item, link){
      // Set state first so the modal renders, then scroll its body to the top.
      // $nextTick ensures the element exists in the DOM before scrolling.
      this.selectedCf = link
      this.selectedPolicy = item
      this.modals.policy = true
      this.$nextTick(() => {
        const root = document.getElementById('cfPolicyModal')
        if(root) root.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      })
    },
    agreeToPolicy(){
      this.recordInteraction(this.selectedPolicy)
      if(this.handleCustomFieldInput(this.selectedCf)){
        this.$set(this.customFieldResponses, this.selectedCf.custom_field_id, true)
        // Force re-render so the base-checkbox visually reflects the new state
        this.j++
      }
      this.modals.policy = false
      // Clear modal state so the next openPolicy doesn't briefly flash stale content during the open animation
      this.selectedCf = null
      this.selectedPolicy = null
    },
    acknowledgeDropdownPopup(){
      // Mark the option as interacted so any future gating sees the user read the popup.
      if(this.popupOption){
        this.recordInteraction(this.popupOption)
      }
      this.modals.dropdown_popup = false
      // Clear so the next selectDropdown popup doesn't briefly flash stale content
      this.popupOption = null
    },
    selectDropdown(link, option){
      const response = {
        name: option.name,
        has_follow_up_field: !!option.has_follow_up_field,
        follow_up_field_label: option.follow_up_field_label || '',
        follow_up_response: ''
      }
      this.$set(this.customFieldResponses, link.custom_field_id, response)
      this.j++
      if(option.has_popup && option.description){
        this.popupOption = option
        this.modals.dropdown_popup = true
      }
    },
    getDropDownLabel(item){
      if(item){
        return item.name
      }
      return ''
    },
    handlePhoneUpdate(phoneData) {
      this.user.phoneE164 = phoneData.e164;
      this.user.phoneValidationStatus = phoneData.validationStatus || 'valid';
      this.user.phoneValidationMessage = phoneData.validationMessage || '';
    },
    getDateMask(date_format){
      switch (date_format) {
        case 'DD/MM/YYYY':
          return '##/##/####';
        case 'MM/DD/YYYY':
          return '##/##/####';
        case 'YYYY/MM/DD':
          return '####/##/##';
        case 'DD MMM YYYY':
          return '## AAA ####';
        case 'MMMM DD, YYYY':
          return '';
        default:
          return '##/##/####'; // Fallback to MM/DD/YYYY
      }
    },
    getDatePlaceholder(date_format){
      const prefix = this.$t('dates.examplePrefix');
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      const exampleDay = '28';
      const exampleMonthIdx = 5; // June (0-based index)
      const exampleYear = '2000';

      switch (date_format) {
        case 'DD/MM/YYYY':
          return `${prefix}${exampleDay}/06/${exampleYear}`;
        case 'MM/DD/YYYY':
          return `${prefix}06/${exampleDay}/${exampleYear}`;
        case 'YYYY/MM/DD':
          return `${prefix}${exampleYear}/06/${exampleDay}`;
        case 'DD MMM YYYY':
          return `${prefix}${exampleDay} ${shortMonths[exampleMonthIdx]} ${exampleYear}`;
        case 'MMMM DD, YYYY':
          return `${prefix}${months[exampleMonthIdx]} ${exampleDay}, ${exampleYear}`;
        default:
          return `${prefix}06/${exampleDay}/${exampleYear}`; // Fallback to MM/DD/YYYY
      }
    },
    sanitizeNameInput(name) {
      if (!name || typeof name !== 'string') return '';

      // Normalize spacing
      name = name.trim().replace(/\s+/g, ' ');

      // Disallow email addresses
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(name)) return '';

      // Disallow phone numbers (7+ digits)
      const digitsOnly = name.replace(/[\s\-\(\)+]/g, '');
      if (/^\d{7,}$/.test(digitsOnly)) return '';

      // Require at least one valid letter (Latin or Greek)
      if (!/[a-zA-Z\u0370-\u03FF\u1F00-\u1FFF]/.test(name)) return '';

      // Disallow common bad values
      const bad = ['n/a', 'na', 'test', 'unknown', 'none'];
      if (bad.includes(name.toLowerCase())) return '';

      // Enforce length limits
      if (name.length < 2 || name.length > 100) return '';

      return name;
    },
    filteredSlots(slots) {
      const now = moment(getNow());
      const config = this.waiverConfigurations || {};
      const effectiveToday = this.effectiveToday();
      // True only between midnight and the rollover time, when the operating day
      // is still yesterday's calendar date.
      const lateNight = effectiveToday !== now.format('YYYY-MM-DD');
      // Some endpoints return booking_date/end_date as date-only ("2026-06-26"),
      // others as an ISO datetime ("2026-06-26T04:00:00.000Z"). Normalize to the
      // date portion so the moment parse below works for both sources.
      const datePart = (d) => String(d || '').split('T')[0];
      return slots.filter((slot) => {
        const isOperatingDaySlot = lateNight && datePart(slot.booking_date) === effectiveToday;
        // During the late-night window the operating day's slots filter by end time
        // (an in-progress 11:55PM game must stay available); a slot without end
        // fields stays visible for the rest of the window.
        const useEnd = config.past_slot_mode === 'end' || isOperatingDaySlot;
        if (useEnd && slot.end_date && slot.end_time) {
          return moment(`${datePart(slot.end_date)} ${slot.end_time}`, 'YYYY-MM-DD HH:mm:ss.SSSSSS').isSameOrAfter(now);
        }
        if (isOperatingDaySlot) return true;
        return moment(`${datePart(slot.booking_date)} ${slot.start_time}`, 'YYYY-MM-DD HH:mm:ss.SSSSSS').isSameOrAfter(now);
      });
    },
    validateBirthdayValue(raw) {
      if (this.birthdayMode === 'typed') {
        return {
          validDate: this.isValidDate(raw),
          reasonableAge: this.isReasonableAge(raw),
          underEighteen: this.isUnderEighteen(raw)
        }
      }
      const valid = isValidIsoDate(raw)
      const age = ageFromIsoDate(raw)
      return {
        validDate: valid ? raw : false,
        reasonableAge: valid && age >= 0 && age <= 120,
        underEighteen: valid && age < 18
      }
    },
    isValidDate(dateString) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy' : {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {

          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          // month = shortMonths.indexOf(monthName); // Find month index
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const dateObj = new Date(year, month, day);
      if (
        dateObj.getFullYear() !== year ||
        dateObj.getMonth() !== month ||
        dateObj.getDate() !== day ||
        isNaN(dateObj.getTime())
      ) {
        return false;
      }

      // Return in YYYY-MM-DD format
      const formattedYear = dateObj.getFullYear();
      const formattedMonth = String(dateObj.getMonth() + 1).padStart(2, '0'); // 1-based months
      const formattedDay = String(dateObj.getDate()).padStart(2, '0');
      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    },
    isReasonableAge(birthday) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      // Parse birthday based on date_format
      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {
          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const birthDate = new Date(year, month, day);
      if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month ||
        birthDate.getDate() !== day ||
        isNaN(birthDate.getTime())
      ) {
        return false;
      }

      // Calculate age
      const today = new Date(); // June 10, 2025
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      // Check if age is reasonable
      return age >= 0 && age <= 120;
    },
    isUnderEighteen(birthday) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      // Parse birthday based on date_format
      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {
          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const birthDate = new Date(year, month, day);
      if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month ||
        birthDate.getDate() !== day ||
        isNaN(birthDate.getTime())
      ) {
        return false;
      }

      // Calculate age
      const today = new Date(); // June 10, 2025
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      // Check if under 18
      return age < 18;
    },
    removeChild(index){
      this.minors.splice(index, 1);
    },
    getArrowSetting(images){
      if(!images){
        return ''
      }
      if(images.length <= 1){
        return 'never'
      }
      return "hover"
    },
    // First event image for the confirm-step thumbnail. The stored x/y/scale are
    // composed for the 200px carousel box, so the thumbnail ignores them and
    // just covers its own box.
    checkInThumb(game){
      if(!game || !game.game_images) return null
      const images = this.gameImagesFor(game.game_images)
      return images.length > 0 && images[0].url ? images[0] : null
    },
    gameImagesFor(rawGameImages){
      return parseGameImages(rawGameImages, this.windowWidth <= MOBILE_BREAKPOINT)
    },
    backButton(){
      // Walk-in starts at step 3, so there is nothing to go back to from there.
      if(this.is_walkin && this.currentStep === 3){
        return
      }
      if(this.currentStep === 7 &&
        (this.display.includes('Experience') || this.display.includes('Location') || this.display.includes('Source') || this.customFieldsForStep(6).length > 0)){
        this.currentStep = 6
        return
      } else if (this.currentStep === 7) {
        this.currentStep = 6
      }

      if(this.currentStep === 6 &&
        (this.display.includes('Signature') ||
          this.waiverConfigurations.waiver_text != null ||
          this.waiverConfigurations.external_link != null ||
          this.display.includes('Photo Opt Out')
          || this.display.includes('Email Opt Out'))){
            this.currentStep = 5
            return
      } else if (this.currentStep === 6) {
        this.currentStep = 5
      }

      if(this.currentStep === 5  &&
        (this.display.includes('Child First Name') || this.display.includes('Child Last Name') || this.display.includes('Child Birthday'))){
        this.currentStep = 4
        this.has_minors = false
        return
      } else if (this.currentStep === 5){
        this.currentStep = 4
      }

      if(this.currentStep === 4  &&
        this.display.includes('Email')){
        this.has_minors = false
        this.currentStep = 3

        return
      } else if (this.currentStep === 4){
        this.currentStep = 3
      }

      if(this.currentStep === 3 && this.waiverConfigurations.multiple_games == true){
        if(this.waiverConfigurations.is_compact){
          this.currentStep = 0
        } else {
          this.currentStep = 2
        }
        return
      } else if (this.currentStep === 3){
        if(this.waiverConfigurations.is_compact){
          this.currentStep = 0
        } else {
          this.currentStep = 2
        }
      }

      if(this.currentStep === 2 && (this.display.includes('Booking Time') && this.display.includes('Booking Date'))){
        this.currentStep = 1
        return
      } else if (this.currentStep === 2){
        this.currentStep = 1
      }

      if(this.currentStep === 1){
        this.currentStep = 0
        return
      }

      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };

      // this.currentStep = parseInt(this.currentStep) - 1
    },
    getDayOfWeek(d){
      if(this.locale.show_day_of_week){
        return dayOfWeek(d)
      }
      return ''
    },
    selectAdditionalGames(){
      //don't add the same booking slot
      let match = _.filter(this.checkInGames, _.matches({booking: this.selectedBooking}))
      if(match.length <= 0){
        this.checkInGames.push({
          game: this.selectedGame,
          booking: this.selectedBooking
        })
      }
      this.currentStep = 0
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    noAdditionalGames(){
      //don't add the same booking slot (guest can come back here from step 3 and answer again)
      let match = _.filter(this.checkInGames, _.matches({booking: this.selectedBooking}))
      if(match.length <= 0){
        this.checkInGames.push({
          game: this.selectedGame,
          booking: this.selectedBooking
        })
      }
      this.currentStep = 3

      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    disabledDates(time) {
      return moment(time).isBefore(this.effectiveToday(), 'day');
    },
    getFormattedDate(format, d){
      return formattedDate(format, d)
    },
    // The venue's operating day: before day_rollover_time (venue clock), the
    // previous calendar date is still "today" so late-night groups can reach
    // their waivers. Defaults to the plain calendar date until the config loads.
    effectiveToday(){
      const rollover = (this.locale && this.locale.day_rollover_time) || '00:00:00'
      const now = moment(getNow())
      if (now.format('HH:mm:ss') < rollover) {
        now.subtract(1, 'day')
      }
      return now.format('YYYY-MM-DD')
    },
    setToday(){
      this.current = this.effectiveToday()
    },
    showPrevious(d){
      if(!d) return false
      return moment(d, 'YYYY-MM-DD').isAfter(this.effectiveToday(), 'day')
    },
    changeDate(){
      if(this.waiverConfigurations.is_compact){
        this.getGames(this.waiverConfigurations.company_group_id)
      } else {
        this.getBookingsForGame(this.selectedGame.id)
      }

    },
    decrementDay(d){
      this.current = moment(d, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
      if(this.waiverConfigurations.is_compact){
        this.getGames(this.waiverConfigurations.company_group_id)
      } else {
        this.getBookingsForGame(this.selectedGame.id)
      }
    },
    incrementDay(d){
      this.current = moment(d, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')

      if(this.waiverConfigurations.is_compact){
        this.getGames(this.waiverConfigurations.company_group_id)
      } else {
        this.getBookingsForGame(this.selectedGame.id)
      }

    },
    getUserInfo() {
      return new Promise ( function(resolve) {
        Auth.currentUserInfo()
          .then(data =>{
            resolve(data)
          })
          .catch(err => console.log(err))
      })
    },
    isMinor(is_minor){

      if(is_minor == 0){
        if (this.display.includes('Signature') || this.waiverConfigurations.waiver_text != null || this.waiverConfigurations.external_link != null){
          this.currentStep = 5
          if (window !== window.top) {
            this.$nextTick(() => {
              this.updateParentAboutHeightChange()
            });
          };
          return
        } else if (this.display.includes('Experience') || this.display.includes('Location') || this.display.includes('Source') || this.customFieldsForStep(6).length > 0){
          this.currentStep = 6
          if (window !== window.top) {
            this.$nextTick(() => {
              this.updateParentAboutHeightChange()
            });
          };
          return
        }
        this.currentStep = 7
      } else {
        this.has_minors = true
      }
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    setMinorData(){
      //validate
      let errors = 0
      for(let n in this.minors){
        if(this.requiredFields.includes('Child First Name') &&
          (this.minors[n].first_name === '' || !this.minors[n].first_name || this.sanitizeNameInput(this.minors[n].first_name) === '')){
          this.minors[n].error_first_name = this.$t('checkin.errors.firstName')
          errors++
        } else {
          this.minors[n].error_first_name = ''
        }
        if(this.requiredFields.includes('Child Last Name') &&
          (this.minors[n].last_name === '' || !this.minors[n].last_name || this.sanitizeNameInput(this.minors[n].last_name) === '')){
          this.minors[n].error_last_name = this.$t('checkin.errors.lastName')
          errors++
        } else {
          this.minors[n].error_last_name = ''
        }
        let { validDate, reasonableAge } = this.validateBirthdayValue(this.minors[n].birthday)
        if(this.requiredFields.includes('Child Birthday') && (!this.minors[n].birthday || this.minors[n].birthday == '')){
          errors++
          this.minors[n].error_birthday = this.$t('checkin.errors.birthdayEmpty')
        } else if((this.minors[n].birthday != '') && (!validDate || !reasonableAge)) {
          this.minors[n].error_birthday = this.$t('checkin.errors.birthday')
          errors++
        } else {
          this.minors[n].error_birthday = ""
        }
        this.minors[n].formatted_birthday = validDate

        this.x++
      }
      errors += this.validateCustomFieldsForStep(4)
      if(errors > 0){
        return
      }

      if (this.display.includes('Signature') || this.waiverConfigurations.waiver_text != null || this.waiverConfigurations.external_link != null){
        this.currentStep = 5
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      } else if (this.display.includes('Experience') || this.display.includes('Location') || this.display.includes('Source') || this.customFieldsForStep(6).length > 0){
        this.currentStep = 6
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      }
      this.currentStep = 7
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    addMinor(){
      this.minors.push(
        {
          fist_name: '',
          last_name: '',
          birthday: ''
        }
      )
    },
    getSignature () {
      if(this.$refs.signaturePad == undefined){
        return
      }
      var png =  this.$refs.signaturePad.saveSignature().data
      if (this.$refs.signaturePad.isEmpty()) {
        return ''
      } else {
        return png
      }
    },
    clearSignature(){
      this.$refs.signaturePad.clearSignature()
    },
    setMarketingData(){
      let errors = 0
      if(this.selectedSource == '' && this.requiredFields.includes('Source')){
        errors++
        this.errs.source = this.$t('checkin.errors.source')
      } else {
        this.errs.source = ''
      }
      if(this.selectedExperience == '' && this.requiredFields.includes('Experience')){
        errors++
        this.errs.experience = this.$t('checkin.errors.experience')
      } else {
        this.errs.experience = ''
      }
      if(this.selectedState == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.state = this.$t('checkin.errors.location')
      } else {
        this.errs.location.state = ''
      }
      if(this.city == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.city = this.$t('checkin.errors.location')
      } else {
        this.errs.location.city = ''
      }
      if(this.zip == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.zip = this.$t('checkin.errors.location')
      } else {
        this.errs.location.zip = ''
      }
      errors += this.validateCustomFieldsForStep(6)
      if(errors > 0){
        return
      }
      this.currentStep = 7
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    setSignatureData(){
      this.signature = this.getSignature()
      let errors = 0

      if(this.signature == ''){
        errors++
        this.errs.signature = this.$t('checkin.errors.signature')
      } else {
        this.errs.signature = ''
      }
      if(this.waiverConfigurations.external_link != null && this.conditions == false){
        errors++
        this.errs.conditions = this.$t('checkin.errors.tos')
      } else {
        this.errs.conditions = ''
      }
      errors += this.validateCustomFieldsForStep(5)
      if(errors > 0){
        return
      }
      if (this.display.includes('Experience') || this.display.includes('Location') || this.display.includes('Source') || this.customFieldsForStep(6).length > 0){
        this.currentStep = 6
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      }
      this.currentStep = 7
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    getSource(){
      if(this.selectedSource.value === 'Other'){
        return this.otherSource.toLowerCase()
      } else {
        if(this.selectedSource.hasOwnProperty('value')){
          return this.selectedSource.value.toLowerCase()
        }
        return ''
      }
    },
    async confirmCheckin(){
      // Validate any "Final step" custom fields rendered above the confirm button before submitting.
      // Section 7 fields live on the confirmation screen since the kiosk has no separate post-marketing step.
      if(this.validateCustomFieldsForStep(7) > 0){
        return
      }
      // Filter out empty minors without mutating the original array
      let minorsForSubmission = this.minors.filter(minor => minor.first_name || minor.last_name)

      // Create copies with formatted birthdays for the API payload
      // Do NOT mutate this.user.birthday or this.minors[m].birthday
      // so validation still works if the user goes back after an error
      minorsForSubmission = minorsForSubmission.map(minor => ({
        ...minor,
        birthday: minor.formatted_birthday
      }))

      this.loading = true
      let url = API_LOCATION + 'checkin'

      // Flatten custom field responses into [{custom_field_id, response}, ...]
      // Booleans (checkbox type) serialize as '1'/'0' strings to match the response column shape.
      // Dropdowns store the option object — format with optional follow-up text appended.
      const customFieldResponses = this.customFieldLinks
        .filter(link => this.isFieldVisible(link))
        .map(link => {
          const raw = this.customFieldResponses[link.custom_field_id]
          let response = ''
          if(link.type === 1){
            response = raw ? '1' : '0'
          } else if(link.type === 3 && raw && typeof raw === 'object'){
            const fu = (raw.follow_up_response || '').trim()
            if(raw.has_follow_up_field && fu){
              response = (raw.name || '') + ': ' + fu
            } else {
              response = raw.name || ''
            }
          } else if(raw != null){
            response = String(raw)
          }
          return { custom_field_id: link.custom_field_id, response }
        })

      let data = {
        waiver_configuration_id: this.waiverConfigurations.id,
        company_id: this.waiverConfigurations.company_id,
        user: {
          ...this.user,
          birthday: this.user.formatted_birthday,  // Use formatted version for API
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        bookings: this.checkInGames,
        minors: minorsForSubmission,
        signature: this.signature,
        picture_optout: this.isOptInMode('Photo Opt Out') ? !this.picture_optout : this.picture_optout,
        email_optout: this.isOptInMode('Email Opt Out') ? !this.email_optout : this.email_optout,
        experience: this.selectedExperience.hasOwnProperty('value') ? this.selectedExperience.value.toLowerCase()  : '',
        location_city: this.city,
        location_state: this.selectedState,
        location_zip: this.zip,
        source: this.getSource(),
        not_participating: this.not_participating,
        custom_field_responses: customFieldResponses,
        locale: this.$i18n.locale,
        easy_checkin: this.easyCheckin
      }


      this.axios.post(url, data)
        .then(response => {
          this.loading = false
          this.disabled = true
          swal({
            title: this.$t('checkin.swals.congratulations'),
            text: this.$t('checkin.swals.allSet'),
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#fd5d93',
            confirmButtonText: 'OK'
          }).then((response)=> {
            window.location.reload();
          })
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
          if(err.response.data == 'Waiver record already exists'){
            swal({
              title: this.$t('checkin.swals.error'),
              text: this.$t('checkin.swals.alreadyCheckedIn'),
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#fd5d93',
              confirmButtonText: 'OK'
            })
          }
        })
    },
    getDisplayTime(slot){
      return displayTime(slot, this.locale.time_format)
    },
    // Slot buttons only reserve a second line (uniform taller height) when at least
    // one slot in the rendered list actually has a booker name; a day with no names
    // keeps the original compact button height.
    hasBookedNames(slots){
      return Array.isArray(slots) && slots.some(s => s.booked_name)
    },
    getGames (id) {
      let url = API_LOCATION + 'company-groups/' + id + '/games?date=' + this.current
      if (this.waiverConfigurations.show_booked_name_on_slots) {
        url += '&include_booked_names=1'
      }
      axios.get(url)
        .then(response => {
          this.gameOptions = response.data
          for(let n in this.gameOptions){
            if(this.waiverConfigurations.hide_past_slot) {
              this.gameOptions[n].slots = _.orderBy(this.filteredSlots(JSON.parse(this.gameOptions[n].slots)), 'start_time')
            } else {
              this.gameOptions[n].slots = _.orderBy(JSON.parse(this.gameOptions[n].slots), 'start_time')
            }

            for(let m in this.gameOptions[n].slots){
              for(let k in this.checkInGames){
                if(this.gameOptions[n].slots[m].id === this.checkInGames[k].booking.id){
                  this.gameOptions[n].slots[m].selected = true
                }
              }
            }
          }
          if(this.waiverConfigurations.hide_past_slot){
            this.startAutoRefresh(this.refreshIntervalId)
          }

          this.j++

          if (window !== window.top) {
            this.$nextTick(() => {
              this.updateParentAboutHeightChange()
            });
          };
        })
        .catch(err => {
          console.log(err)
        })
    },
    isEmailValid(emailString) {
      // Use centralized email validator utility with comprehensive TLD whitelist
      return isValidEmail(emailString);
    },
    getWaiverConfigurations(){
      this.loading = true
      var code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/waiver'
      if(this.is_walkin){
        url += '?type=generic'
      }

      axios.get(url)
        .then(response => {
          this.notFound = false
          this.waiverConfigurations = response.data.config[0]
          document.documentElement.style.setProperty('--input-border-color', inputBorderColor(this.waiverConfigurations))
          this.fields = response.data.fields
          this.sections = response.data.sections
          if(this.is_walkin){
            // Generic configs have sections at positions 3-7 only. Pad two placeholders so
            // the hardcoded template indices (sections[0]..sections[6]) and stepToSectionIndex
            // keep lining up; steps 0-2 never render in walk-in mode so the placeholders
            // never display.
            this.sections = [{ name: '', position: 1 }, { name: '', position: 2 }, ...this.sections]
          }
          this.locale = response.data.locale
          syncServerNow(response.data.server_now)
          applyPageLocale(this.locale && this.locale.default_locale, this.waiverConfigurations && Number(this.waiverConfigurations.show_language_switcher) === 1)
          this.customFieldLinks = response.data.custom_field_links || []
          // Build the full responses object first then assign once, so Vue 2 makes
          // every key reactive at construction time. Adding keys to a previously-
          // assigned plain `{}` would skip Vue's reactive walker and bind stale.
          const initialResponses = {}
          for(const link of this.customFieldLinks){
            // type 1 = checkbox (boolean), 2 = input field (string), 3 = dropdown (object)
            initialResponses[link.custom_field_id] = (link.type === 1) ? false : ''
          }
          this.customFieldResponses = initialResponses
          for(let n in this.fields){
            if(this.fields[n].is_active == 1){
              this.display.push(this.fields[n].name)
              if(this.fields[n].is_required){
                this.requiredFields.push(this.fields[n].name)
              }
            }
          }
          this.country = _.find(this.countries, { code: this.locale.country })

          if(this.locale.country !== 'US'){
            this.state_placeholder = this.$t('checkin.country')
          }
          if(this.locale.show_day_of_week){
            this.day_of_week = 'ddd, '
          }

          this.dateMask = this.getDateMask(this.locale.date_format)
          this.datePlaceholder = this.getDatePlaceholder(this.locale.date_format)

          //Fix year for el date picker
          this.locale.date_format = this.locale.date_format.replaceAll('Y', 'y')
          this.locale.date_format = this.locale.date_format.replaceAll('D', 'd')

          this.loading = false
          if(this.is_walkin){
            // Walk-in starts at the personal info step; no game/date/time selection and
            // no slot loading (which would otherwise start the auto-refresh interval).
            this.currentStep = 3
          } else {
            // Recompute the day now that the venue clock and rollover are known;
            // the setToday() in mounted() ran before the config arrived.
            this.setToday()
            this.getGames(this.waiverConfigurations.company_group_id)
          }
        })
        .catch(err => {
          this.loading = false
          this.notFound = true
          console.log(err)
        })
    },
    selectGame(game){
      this.currentStep = 1
      this.selectedGame = game
      this.getBookingsForGame(this.selectedGame.id)

    },
    async getBookingsForGame(gameId){
      this.loading = true
      let today = this.effectiveToday()
      let url = API_LOCATION + 'games/' + gameId + '/bookings?from=' + this.current + `&to=` + this.current + '&date=' + today
      if (this.waiverConfigurations.show_booked_name_on_slots) {
        url += '&include_booked_names=1'
      }
      axios.get(url)
        .then(response => {
          syncServerNow(response.data.server_now)
          this.loading = false
          this.bookings = this.waiverConfigurations.hide_past_slot
            ? this.filteredSlots(response.data.booking_slots)
            : response.data.booking_slots
          if(this.bookings.length <= 0){
            this.noBookingsAvailable = true
          } else {
            this.noBookingsAvailable = false
          }

        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    setUserData(){
      let errors = 0
      // Easy check-in: server merges name/phone/birthday from prior waiver — skip user-info gates only.
      // Custom fields, signature, ToS, and downstream validation still apply.
      if (!this.easyCheckin) {
        if(this.isEmailValid(this.user.email) == false){
          errors++
          this.errs.email = this.$t('checkin.errors.email')
        } else {
          this.errs.email = ''
        }
        if((this.user.first_name === '' || this.sanitizeNameInput(this.user.first_name) === '')
          && this.requiredFields.includes('First Name')){
          errors++
          this.errs.first_name = this.$t('checkin.errors.firstName')
        } else {
          this.errs.first_name = ''
        }
        if((this.user.last_name === '' || this.sanitizeNameInput(this.user.last_name) === '')
          && this.requiredFields.includes('Last Name')){
          errors++
          this.errs.last_name = this.$t('checkin.errors.lastName')
        } else {
          this.errs.last_name = ''
        }
        let { validDate, reasonableAge, underEighteen } = this.validateBirthdayValue(this.user.birthday)

        if((!validDate || !reasonableAge || underEighteen) && this.requiredFields.includes('Birthday')){
          errors++
          this.errs.birthday = this.$t('checkin.errors.birthday')
        } else if(this.user.birthday !== '' && (!validDate || !reasonableAge || underEighteen)) {
          errors++
          this.errs.birthday = this.$t('checkin.errors.birthday')
        } else {
          this.errs.birthday = ''
        }
        this.user.formatted_birthday = validDate

        if(this.user.phone == '' && this.requiredFields.includes('Phone')){
          errors++
          this.errs.phone = this.$t('checkin.errors.phone')
        } else if(this.user.phoneValidationStatus === 'invalid' && this.requiredFields.includes('Phone')) {
          errors++
          this.errs.phone = this.$t('book.errors.phoneInvalid')
        } else {
          this.errs.phone = ''
        }
      }
      errors += this.validateCustomFieldsForStep(3)
      if(errors > 0){
        return
      }
      if(this.display.includes('Child First Name') || this.display.includes('Child Last Name') || this.display.includes('Child Birthday')){
        this.currentStep = 4
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      } else if (this.display.includes('Signature') || this.waiverConfigurations.waiver_text != null || this.waiverConfigurations.external_link != null){
        this.currentStep = 5
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      } else if (this.display.includes('Experience') || this.display.includes('Location') || this.display.includes('Source') || this.customFieldsForStep(6).length > 0){
        this.currentStep = 6
        if (window !== window.top) {
          this.$nextTick(() => {
            this.updateParentAboutHeightChange()
          });
        };
        return
      }
      this.currentStep = 7
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    unselectBookingCompactView(slot){
      slot.selected = false

      const index = this.checkInGames.findIndex(c => c.booking.id === slot.id)
      if(index !== -1){
        this.checkInGames.splice(index, 1)
      }
    },
    // Confirm-step removal. Compact mode flags the slot buttons on step 0 via
    // `selected`, so clear that flag too or the slot still shows as checked
    // after the guest navigates back.
    removeCheckInGame(index){
      if(this.checkInGames.length <= 1){
        return
      }
      const removed = this.checkInGames.splice(index, 1)[0]
      if(removed && Array.isArray(this.gameOptions)){
        for(const game of this.gameOptions){
          if(!Array.isArray(game.slots)) continue
          const slot = game.slots.find(s => s.id === removed.booking.id)
          if(slot){
            slot.selected = false
          }
        }
      }
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    selectMultipleCompact(){
      if(this.checkInGames.length <= 0){
        return
      }
      this.currentStep = 3
    },
    selectBookingCompactView(slot, game){
      if(this.waiverConfigurations.multiple_games == 1){
        slot.selected = true
        this.checkInGames.push({
          game: game,
          booking: slot
        })
      } else {
        this.checkInGames = [{
          game: game,
          booking: slot
        }]
        this.currentStep = 3
      }

    },
    async selectBookingDate(booking){

      this.selectedBooking = booking
      if(this.waiverConfigurations.multiple_games == 1){
        this.currentStep = 2
      } else {
        if(this.waiverConfigurations.multiple_games == false){
          this.checkInGames = [{
            game: this.selectedGame,
            booking: this.selectedBooking
          }]

        } else {
          this.checkInGames.push({
            game: this.selectedGame,
            booking: this.selectedBooking
          })
        }
        this.currentStep = 3
      }
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutHeightChange()
        });
      };
    },
    async getUser(){
      let user = await this.getUserInfo()
      let redirect = '/checkin/' + this.$route.params.company
      if(user == null){
        localStorage.setItem('redirect', redirect)
      }
    },
    updateParentAboutHeightChange() {
      const height = this.$el.scrollHeight; //
      window.parent.postMessage({action: 'updateHeight', height: height + 20}, '*');
    },
    updateSlots(){
      for(let n in this.gameOptions){
        this.gameOptions[n].slots = _.orderBy(this.filteredSlots(this.gameOptions[n].slots), 'start_time')

        for(let m in this.gameOptions[n].slots){
          for(let k in this.checkInGames){
            if(this.gameOptions[n].slots[m].id === this.checkInGames[k].booking.id){
              this.gameOptions[n].slots[m].selected = true
            }
          }
        }
      }
      // Non-compact mode renders the step-1 slot list off this.bookings, not
      // gameOptions, so re-filter it too or past slots linger until a refetch.
      if(!this.waiverConfigurations.is_compact && this.bookings && this.bookings.length){
        this.bookings = this.filteredSlots(this.bookings)
      }
    },
    startAutoRefresh(id, interval = 300000) {
      if (this.refreshIntervalId) {
        clearInterval(this.refreshIntervalId);
      }

      // Start the interval
      this.refreshIntervalId = setInterval(() => {
        this.updateSlots(id);
      }, interval);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onWindowResize)
  },
  mounted() {
    this._onWindowResize = () => { this.windowWidth = window.innerWidth }
    window.addEventListener('resize', this._onWindowResize)
    if(this.$route.name === 'Checkin-kiosk'){
      this.is_kiosk = true
    }
    if(this.$route.name === 'Checkin-walkin'){
      this.is_walkin = true
    }

    this.setToday()
    this.getUser()
    this.getWaiverConfigurations()
  }
}
</script>

<style scoped>
.game-button{
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;

}
.sig-pad {
  border: #344675 2px solid;
  border-radius: 5px;
}


.checkin-summary{
  margin-bottom: 1rem;
}
.checkin-summary-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 6px;
  background: rgba(125, 125, 125, 0.12);
}
.checkin-summary-row + .checkin-summary-row{
  margin-top: 8px;
}
.checkin-summary-thumb{
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
}
.checkin-summary-thumb img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.checkin-summary-info{
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: start;
}
.checkin-summary-name{
  font-weight: 600;
  overflow-wrap: anywhere;
}
.checkin-summary-when{
  font-size: 0.85em;
  opacity: 0.8;
}
.checkin-summary-remove{
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkin-summary-remove:hover,
.checkin-summary-remove:focus-visible{
  background: rgba(125, 125, 125, 0.15);
  outline: none;
}

.empty-bookings{
  text-align: center;
  padding: -10px 5px -10px;
  /*margin-bottom: -30px;*/
  border: 1px solid #e44cc4;
  border-radius: .1875rem;
  min-height: 90px;
  flex: 1;
}
.empty-bookings i{
  font-size: 1em;
  margin: 0px 0 -10px;
}

.empty-bookings p{
  padding: 7px;
  /*margin-top: 30px;*/
  font-size: 0.8em;
}


</style>
